module.exports = __webpack_public_path__ + "img/cny-1.2fdf4ee6.png";